module.exports = __webpack_public_path__ + "h5/img/hong-kong-listing.9fe18116.webp";